module.exports = __webpack_public_path__ + "static/scale-model-of-memphis-escape-rooms-in-memphis-tennessee-e2e6c0a44aebf677eae9cc3a10e157a0.png";